export const DATE_PICKER_DATE_FORMAT = 'MM-DD-YYYY';
export const DATE_PICKER_DATE_FORMAT_DD_MM_YYYY = 'DD-MM-YYYY';
export const DATE_PICKER_DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
export const DATE_PICKER_TODAY_MAX_DATE = new Date();



// WEBPACK FOOTER //
// ./src/constants/dates.js